import React, { useEffect, useRef, useState } from 'react'
import { connect } from 'react-redux'
import { useHistory } from 'react-router'
import { webSerialAction } from '../../../../redux/actions/index'
import renderImage from '../../../../source/importImg'
import unicodeToChar from '../../../../utils/unicodeToChar'
import SpchSlider from '../../../ReusableComponents/SpchSlider/SpchSlider'
import MainHeader from '../../../ReusableComponents/Header/MainHeader'
import './speak.scss'
import { sendBytes } from '../../../ReusableComponents/ByteTransfer'
import cacheAssets from '../../../../utils/cacheAssets'
import { languageWords } from '../../../../utils/langaugeSupport'
import { getConnectedDeviceName, withBrandDeviceImage } from '../../../../hooks/useBrandConfig'

try {
    var SpeechRecognition =
        window.SpeechRecognition || window.webkitSpeechRecognition
    var recognition = new SpeechRecognition()
} catch (e) {}

function AceSpeech(props) {
    let history = useHistory()
    const languageName = props.device.language
    const connectedDevice = sessionStorage.getItem('connectedDevice')
    const deviceVersion = sessionStorage.getItem('deviceVersion')
    const connectedDeviceName = getConnectedDeviceName(
        connectedDevice,
        deviceVersion
    )

    // const gobackUrl = () => {
    //   history.goBack();
    // };

    const [isMic, setMic] = useState(false)

    // isMicRef mirrors isMic so recognition.onend can read the latest value
    // without a stale closure — used to auto-restart recognition after each result.
    const isMicRef = useRef(false)

    // writePortRef always points to the current-render writePort function.
    // recognition.onresult is only set when handleMic is called, so without this
    // ref it would hold a stale closure over old props — causing writePort to
    // check an old props.webSerial.isConnected value and silently drop bytes
    // after a USB reconnect.
    const writePortRef = useRef(null)

    // Tracks the previous isConnected value so we can detect connect transitions.
    const prevConnected = useRef(false)

    // Keep writePortRef current on every render.
    writePortRef.current = async (data) => {
        if (props.webSerial.port !== undefined && props.webSerial.isConnected) {
            props.worker.postMessage({ type: 'writeArray', value: data })
        }
    }

    const handleMic = () => {
        if (isMic) {
            isMicRef.current = false
            setMic(false)
            recognition.stop()
            return
        }

        isMicRef.current = true
        setMic(true)

        // Auto-restart recognition after each result (or timeout) so the mic
        // stays alive until the user explicitly clicks stop or leaves the page.
        recognition.onend = () => {
            if (isMicRef.current) {
                try {
                    recognition.start()
                } catch (e) {}
            }
        }

        recognition.onstart = () => {
            console.log('Listening!')
        }

        let finalTranscript = ''
        recognition.onresult = (e) => {
            for (let i = e.resultIndex; i < e.results.length; i++) {
                const transcript = e.results[i][0].transcript
                console.log(transcript)
                if (e.results[i].isFinal) finalTranscript += transcript + ' '
            }
            try {
                document.getElementById('final').innerHTML = finalTranscript
            } catch (e) {}

            const isOffCMD = [
                'light off',
                'lights off',
                'smile off',
                'disco off',
            ].some((str) => finalTranscript.toLowerCase()?.includes(str))

            const transcriptArray = finalTranscript.split(' ')
            const stopCmd = transcriptArray.slice(-4, -1)
            console.log('stopCmd', stopCmd)

            const sendCmd = (data) => {
                writePortRef.current(data)
                // Reset transcript so the next spoken command starts clean.
                finalTranscript = ''
            }

            if (stopCmd[0] === 'Light' && stopCmd[1] === 'off.') {
                console.log('forward emit')
                sendCmd(['S'.charCodeAt(), '0'.charCodeAt()])
            } else if (
                stopCmd[0] === 'White' &&
                stopCmd[1] === 'light' &&
                stopCmd[2] === 'on.'
            ) {
                console.log('white light emit')
                sendCmd(['S'.charCodeAt(), '1'.charCodeAt()])
            } else if (
                stopCmd[0] === 'Red' &&
                stopCmd[1] === 'light' &&
                stopCmd[2] === 'on.'
            ) {
                console.log('red light emit')
                sendCmd(['S'.charCodeAt(), '2'.charCodeAt()])
            } else if (finalTranscript.toLowerCase().includes('green')) {
                console.log('green light emit')
                sendCmd(['S'.charCodeAt(), '3'.charCodeAt()])
            } else if (
                stopCmd[0] === 'Blue' &&
                stopCmd[1] === 'light' &&
                stopCmd[2] === 'on.'
            ) {
                console.log('blue light emit')
                sendCmd(['S'.charCodeAt(), '4'.charCodeAt()])
            } else if (finalTranscript.toLowerCase().includes('disco')) {
                console.log('disco light emit')
                sendCmd(['S'.charCodeAt(), '5'.charCodeAt()])
            } else if (
                finalTranscript.toLowerCase().includes('smile') &&
                finalTranscript.toLowerCase().includes('on')
            ) {
                console.log('smile light emit')
                sendCmd(['S'.charCodeAt(), '6'.charCodeAt()])
            } else if (
                ([
                    'light',
                    'lights',
                    'Light',
                    'Lights',
                    'smile',
                    'Smile',
                    'Disco',
                ].includes(stopCmd[0]) &&
                    stopCmd[1] === 'off') ||
                isOffCMD
            ) {
                console.log('forward emit')
                sendCmd(['S'.charCodeAt(), '0'.charCodeAt()])
            } else if (
                stopCmd[0] === 'white' &&
                stopCmd[1] === 'light' &&
                stopCmd[2] === 'on'
            ) {
                console.log('white light emit')
                sendCmd(['S'.charCodeAt(), '1'.charCodeAt()])
            } else if (
                stopCmd[0] === 'red' &&
                stopCmd[1] === 'light' &&
                stopCmd[2] === 'on'
            ) {
                console.log('red light emit')
                sendCmd(['S'.charCodeAt(), '2'.charCodeAt()])
            } else if (
                stopCmd[0] === 'green' &&
                stopCmd[1] === 'light' &&
                stopCmd[2] === 'on'
            ) {
                console.log('green light emit')
                sendCmd(['S'.charCodeAt(), '3'.charCodeAt()])
            } else if (
                stopCmd[0] === 'blue' &&
                stopCmd[1] === 'light' &&
                stopCmd[2] === 'on'
            ) {
                console.log('blue light emit')
                sendCmd(['S'.charCodeAt(), '4'.charCodeAt()])
            } else if (stopCmd[0] === 'stop' && stopCmd[1] === 'listening') {
                isMicRef.current = false
                setMic(false)
                recognition.stop()
                const finalText = transcriptArray.slice(0, -3).join(' ')
                try {
                    document.getElementById('final').innerHTML = finalText
                } catch (e) {}
            } else {
                // Unrecognised — keep mic on, just show feedback.
                try {
                    document.getElementById('final').innerHTML =
                        "I didn't quite catch that, please try again."
                } catch (e) {}
                finalTranscript = ''
            }
        }

        recognition.onerror = (event) => {
            console.log('Error occurred in recognition: ' + event.error)
        }

        try {
            recognition.start()
        } catch (e) {}
    }

    // Send PLAY bytes on every connect / reconnect transition.
    // prevConnected tracks false→true so we call sendPlayBytes exactly once
    // per connection event, regardless of how many renders happen during the
    // disconnect/reconnect cycle. The old module-level `count` + sessionStorage
    // approach had a race condition where a fast reconnect could skip PLAY bytes
    // entirely, leaving the device outside speech mode.
    useEffect(() => {
        const isNowConnected = props.webSerial.isConnected
        if (isNowConnected && !prevConnected.current) {
            sendPlayBytes()
        }
        prevConnected.current = isNowConnected
    }, [props.webSerial.isConnected])

    // Stop recognition when the user leaves the speech page.
    useEffect(() => {
        return () => {
            isMicRef.current = false
            try {
                recognition.stop()
            } catch (e) {}
        }
    }, [])

    const sendPlayBytes = () => {
        const PLAY = [
            'P'.charCodeAt(),
            'L'.charCodeAt(),
            'A'.charCodeAt(),
            'Y'.charCodeAt(),
        ]
        const M8 = ['M'.charCodeAt(), '8'.charCodeAt()]
        const playBytes = setTimeout(() => {
            writePortRef.current(PLAY)
            clearTimeout(playBytes)
        }, 250)
        const clearPin = setTimeout(() => {
            writePortRef.current(M8)
            clearTimeout(clearPin)
        }, 350)
    }

    const [isLanguage, setLanguage] = useState(false)

    const handleLanguageBtn = (e) => {
        if (isLanguage) {
            setLanguage(false)
        } else {
            setLanguage(true)
        }
    }

    const [isHelp, setHelp] = useState(false)

    useEffect(() => {
        let assetsToBeCached = [
            renderImage('speechH'),
            renderImage('speechH1'),
            renderImage('Spch1'),
            renderImage('Spch2'),
        ]
        cacheAssets(assetsToBeCached)
    }, [])

    const handleHelpBtn = (e) => {
        if (isHelp == true) {
            setHelp(false)
        } else {
            setHelp(true)
        }
    }

    const getImgUrl = () => {
        if (connectedDevice === 'Roboki') {
            return withBrandDeviceImage(renderImage('Roboki'), 'Roboki')
        } else {
            return withBrandDeviceImage(renderImage('PC'), 'Ace')
        }
    }

    return (
        <div className="Speech-Main">
            <MainHeader
                title={languageWords[languageName]?.Speech || 'Speech'}
                helper={<SpchSlider />}
                showBluetoothBtn={true}
                goBack={() => {
                    if (['Ace', 'Roboki'].includes(connectedDevice)) {
                        writePortRef.current([
                            'S'.charCodeAt(),
                            '0'.charCodeAt(),
                        ])
                    }
                    sessionStorage.setItem('slideDirection', true)
                    history.push('/introduction')
                }}
                isGoBack={true}
            />

            <div className="Ace_Speech">
                <div>
                    {['Ace', 'Roboki'].includes(connectedDevice) ? (
                        <>
                            {deviceVersion?.startsWith('1') &&
                            connectedDevice === 'Ace' ? (
                                <img
                                    className="Ace_img"
                                    src={withBrandDeviceImage(renderImage('PCv1'), 'Ace')}
                                    style={{
                                        width: '75%',
                                        marginTop: '10%',
                                    }}
                                    draggable="false"
                                />
                            ) : (
                                <img
                                    className="Ace_img"
                                    src={getImgUrl()}
                                    draggable="false"
                                />
                            )}
                        </>
                    ) : (
                        <></>
                    )}
                    {connectedDevice === 'Humanoid' && (
                        <img
                            className="Ace_img"
                            src={renderImage('Zing')}
                            draggable="false"
                        ></img>
                    )}
                </div>
                <div>
                    {isMic == false ? (
                        <img
                            className="Mic_imgIA"
                            src={renderImage('SpeechIA_Svg')}
                            onClick={handleMic}
                            draggable="false"
                        ></img>
                    ) : (
                        <img
                            className="Mic_img"
                            src={renderImage('SpeechAc_Svg')}
                            onClick={handleMic}
                            draggable="false"
                        ></img>
                    )}
                </div>
            </div>
            <div className="SoundWave">
                {isMic == false ? null : (
                    <img
                        className="Sound_Wave"
                        src={renderImage('Soundwaves_Svg')}
                        draggable="false"
                    ></img>
                )}
            </div>
            <div>
                {isMic == false ? (
                    <h3 className="Speech_Instruc">
                        Tap the microphone to start talking to your{' '}
                        {connectedDeviceName}
                    </h3>
                ) : (
                    <h3 id="final" className="Speech_Instruct">
                        Listening......
                    </h3>
                )}
            </div>
        </div>
    )
}

const mapStateToProps = (state) => {
    return state
}
const mapDispatchToProps = (dispatch) => {
    return {
        webSerialAction: (data) => {
            console.log('mapDispatchToProps', data)
            dispatch(webSerialAction(data))
        },
    }
}

export default connect(mapStateToProps, mapDispatchToProps)(AceSpeech)
